import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_CustomValidate = _resolveComponent("CustomValidate")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.VISIBLE))
      ? _withDirectives((_openBlock(), _createBlock(_component_AutoComplete, {
          key: 0,
          container: _ctx.container,
          id: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.ID),
          style: _normalizeStyle(_ctx.getPropertyValue(_ctx.AutocompleteTypeConst.STYLE)),
          class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.AutocompleteTypeConst.CLASS) ?? '']: true, 'p-invalid': _ctx.v$.vmodel.$error && _ctx.submitted, 'p-readonly': _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.READONLY) }),
          name: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.NAME),
          disabled: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.DISABLED),
          visible: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.VISIBLE),
          placeholder: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.PLACEHOLDER),
          suggestions: _ctx.filteredData,
          field: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.FIELD),
          optionLabel: _ctx.fieldSearch,
          optionDisabled: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.OPTIONDISABLED),
          optionGroupLabel: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.OPTIONGROUPLABEL),
          optionGroupChildren: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.OPTIONGROUPCHILDREN),
          scrollHeight: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.SCROLLHEIGHT),
          dropdown: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.DROPDOWN),
          dropdownMode: _ctx.getCatalogValue(_ctx.AutocompleteTypeConst.DROPDOWNMODE),
          autoHighlight: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.AUTOHIGHLIGHT),
          multiple: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.MULTIPLE),
          loading: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.LOADING),
          dataKey: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.DATAKEY),
          minLength: _ctx.getPropertyNumberValue(_ctx.AutocompleteTypeConst.MINLENGTH),
          delay: _ctx.getPropertyNumberValue(_ctx.AutocompleteTypeConst.DELAY),
          appendTo: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.APPENDTO),
          forceSelection: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.FORCESELECTION),
          completeOnFocus: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.COMPLETEONFOCUS),
          inputId: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.INPUTID),
          inputStyle: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.INPUTSTYLE),
          inputClass: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.INPUTCLASS),
          inputProps: _ctx.getInputStyle,
          panelStyle: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.PANELSTYLE),
          panelClass: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.PANELCLASS),
          panelProps: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.PANELPROPS),
          dropdownIcon: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.DROPDOWNICON),
          dropdownClass: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.DROPDOWNCLASS),
          loadingIcon: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.LOADINGICON),
          removeTokenIcon: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.REMOVETOKENICON),
          virtualScrollerOptions: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.VIRTUALSCROLLEROPTIONS),
          autoOptionFocus: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.AUTOOPTIONFOCUS),
          selectOnFocus: _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.SELECTONFOCUS),
          searchLocale: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.SEARCHLOCALE),
          searchMessage: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.SEARCHMESSAGE),
          selectionMessage: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.SELECTIONMESSAGE),
          emptySelectionMessage: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.EMPTYSELECTIONMESSAGE),
          emptySearchMessage: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.EMPTYSEARCHMESSAGE),
          tabindex: _ctx.getPropertyNumberValue(_ctx.AutocompleteTypeConst.TABINDEX),
          ariaLabel: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.ARIALABEL),
          ariaLabelledby: _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.ARIALABELLEDBY),
          modelValue: _ctx.vmodel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
          onComplete: _ctx.search
        }, {
          content: _withCtx((slotProps) => [
            _renderSlot(_ctx.$slots, "content", {
              slotProps: { data: slotProps.items, styleClass: slotProps.styleClass, control: _ctx.ControlTypeConst.CTAUTOCOMPLETE}
            })
          ]),
          header: _withCtx(() => [
            _renderSlot(_ctx.$slots, "header")
          ]),
          footer: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer")
          ]),
          empty: _withCtx(() => [
            _renderSlot(_ctx.$slots, "empty")
          ]),
          optiongroup: _withCtx((slotProps) => [
            _renderSlot(_ctx.$slots, "optiongroup", {
              slotProps: { data: slotProps.option,index:slotProps.index, control: _ctx.ControlTypeConst.CTAUTOCOMPLETE}
            })
          ]),
          option: _withCtx((slotProps) => [
            _renderSlot(_ctx.$slots, "option", {
              slotProps: { data: slotProps.option,index:slotProps.index, control: _ctx.ControlTypeConst.CTAUTOCOMPLETE}
            })
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content")
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "suggestions", "field", "optionLabel", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "scrollHeight", "dropdown", "dropdownMode", "autoHighlight", "multiple", "loading", "dataKey", "minLength", "delay", "appendTo", "forceSelection", "completeOnFocus", "inputId", "inputStyle", "inputClass", "inputProps", "panelStyle", "panelClass", "panelProps", "dropdownIcon", "dropdownClass", "loadingIcon", "removeTokenIcon", "virtualScrollerOptions", "autoOptionFocus", "selectOnFocus", "searchLocale", "searchMessage", "selectionMessage", "emptySelectionMessage", "emptySearchMessage", "tabindex", "ariaLabel", "ariaLabelledby", "modelValue", "onComplete"])), [
          [_directive_tooltip, _ctx.getPropertyValue(_ctx.AutocompleteTypeConst.TOOLTIP)]
        ])
      : _createCommentVNode("v-if", true),
    _hoisted_1,
    (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.AutocompleteTypeConst.VISIBLE))
      ? (_openBlock(), _createBlock(_component_CustomValidate, {
          key: 1,
          submitted: _ctx.submitted,
          "onUpdate:submitted": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitted) = $event)),
          vObject: _ctx.v$,
          "onUpdate:vObject": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$) = $event))
        }, null, 8 /* PROPS */, ["submitted", "vObject"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}